<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div class="container-fluid" *ngIf="isLoaded()">
    <div class="row">
      <div class="col-12">
        <p-panel>
          <p-header>
            <span>
              <i class="fa fa-filter" aria-hidden="true"></i> {{'General.filters' | translate}}</span>
          </p-header>
          <div class="row">
            <div class="col-12">
              <!--
              <formElement [model]="filters" name="from" [fieldConfig]="getFieldConfig(this.FROM_PARAM)" #ref>
              </formElement>
              <formElement [model]="filters" name="to" [fieldConfig]="getFieldConfig(this.TO_PARAM)" #ref>
              </formElement>
              -->
              <formElement [model]="filters" name="user" [fieldConfig]="getFieldConfig(this.USER_PARAM)" #ref>
              </formElement>
              <formElement [model]="filters" name="resource" [fieldConfig]="getFieldConfig(this.RESOURCE)" #ref>
              </formElement>
            </div>
            <div class="col-12">
              <button class="btn btn-primary float-right" (click)="load()"><i class="fa fa-search"
                  aria-hidden="true"></i> {{'General.search.text' | translate}}</button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-b-md">
      <div class="alert alert-info row col-12 ml-1 mr-1" *ngIf="!elements||elements==[]">
        <span><i class="fas fa-info-circle mr-2" aria-hidden="true"></i>{{ 'General.noData' | translate }}</span>
      </div>
      <div class="col-12 m-t-md m-b-md" *ngIf="isLoaded()">
        <p-panel>
          <p-header>
            <span class="leyenda float-right">{{ 'Audit.total' | translate }} {{ elements ? elements.length : '0' }} {{
              'Sessions.sessions' | translate }}</span>
          </p-header>
          <p-table [value]="elements" [responsive]="true" sortField="plannedPeriod.inDate" sortOrder="1">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'General.session' | translate }}</th>
                <th>{{ 'ControlPanel.supportSessions.supportCase' | translate }}</th>
                <th>{{ 'General.project' | translate }}</th>
                <th>{{ 'General.date.ini' | translate }}</th>
                <th class="action-column">{{'General.actions'|translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-element>
              <tr>
                <td>
                  <span class="p-column-title">{{ 'General.session' | translate }}:</span> {{element.identifier}}
                </td>
                <td>
                  <span class="p-column-title">{{ 'ControlPanel.supportSessions.supportCase' | translate }}:</span>
                  {{element.relatedSupportCaseId?element.relatedSupportCaseId:'--'}}
                </td>
                <td>
                  <span class="p-column-title">{{ 'General.project' | translate }}:</span>
                  {{element.projectEntity&&element.projectEntity.contractFolderId?element.projectEntity.contractFolderId:'--'}}
                </td>
                <td>
                  <span class="p-column-title">{{ 'General.date.ini' | translate }}:</span> {{element.startDate| date:
                  'dd/MM/yyyy HH:mm:ss'}}
                </td>
                <td>
                  <div class="action-column">
                    <div class=" btn-group">
                      <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                        title="{{ 'Invoices.reject.tooltip' | translate}}" (click)="remove(element)">
                        <i class="fas fa-times" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="text-center">
                <td colspan="5">
                  <div class="alert alert-info row col-12 ml-1 mr-1">
                    <span><i class="fas fa-info-circle ml-2 mr-2" aria-hidden="true"></i>{{ 'General.noData' | translate
                      }}</span>
                  </div>
                  <!--span>{{ 'General.noData' | translate }}</span-->
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </div>
</div>